import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bea3765"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-box" }
const _hoisted_2 = { class: "relative tags-list" }
const _hoisted_3 = { class: "flex items-center space-x-2" }
const _hoisted_4 = { class: "text-sm" }

import { PropType } from "vue";

import { Tag } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReadonlyTags',
  props: {
  tags: {
    type: Array as PropType<Tag[]>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tags, (item, index) => {
        return (_openBlock(), _createElementBlock("span", {
          class: "bg-gray-200 border border-gray-500 tags-list-item",
          key: index
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(item.name), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})